<template>
  <div class="rc-l-public rc-l-public--experience">
    <div class="rc-l-public--title">
      <div class="container">
        <h1 class="mx-auto">{{ $t("statics.experience.title") }}</h1>
      </div>
    </div>
    <!-- section 1 : Text intro -->
    <div class="rc-section">
      <div class="container text-center">
        <div class="row justify-content-center">
          <div class="col-lg-10 rc-col-text">
            <p
              class="mx-auto rc-intro--xl"
              v-html="$t('statics.experience.section1.text.1')"
            ></p>
            <p
              class="mx-auto rc-intro--xl"
              v-html="$t('statics.experience.section1.text.2')"
            ></p>
          </div>
        </div>
      </div>
    </div>

    <!-- section 2 : Simplified authentication-->
    <section>
      <div class="container">
        <div class="row flex-column-reverse flex-md-row">
          <div
            class="col-md-7 col-lg-6 col-xl-5 offset-xl-1 rc-col-text rc-col-max-width"
          >
            <h2 v-html="$t('statics.experience.section2.title')"></h2>
            <p
              class="rc-intro"
              v-html="$t('statics.experience.section2.text')"
            ></p>
          </div>
          <div class="col-md-5 col-lg-6 col-xl-5">
            <img
              src="/src/assets/img/illustrations/toucan_laptop_combined.svg"
              class="rc-toucan-laptop-combined"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>

    <!-- section 3 : Personalized exploration -->
    <section class="rc-bg-wave-teal-1">
      <div class="container">
        <div class="row">
          <div class="col-md-5 col-lg-6 col-xl-5">
            <img
              src="/src/assets/img/illustrations/personalization_combined.svg"
              alt=""
              class="rc-personalization-combined"
            />
          </div>
          <div
            class="col-md-7 col-lg-6 col-xl-5 offset-xl-1 rc-col-text rc-col-max-width"
          >
            <h2 v-html="$t('statics.experience.section3.title')"></h2>
            <p
              class="rc-intro"
              v-html="$t('statics.experience.section3.text')"
            ></p>
          </div>
        </div>
      </div>
    </section>

    <!-- section 6 : Fascinating recommendations just for you-->
    <section>
      <div class="container">
        <div class="row flex-column-reverse flex-md-row">
          <div
            class="col-md-7 col-lg-6 col-xl-5 offset-xl-1 rc-col-text rc-col-max-width"
          >
            <h2 v-html="$t('statics.experience.section6.title')"></h2>
            <p
              class="rc-intro"
              v-html="$t('statics.experience.section6.text.1')"
            ></p>
            <p
              class="rc-intro"
              v-html="$t('statics.experience.section6.text.2')"
            ></p>
            <p
              class="rc-intro"
              v-html="$t('statics.experience.section6.text.3')"
            ></p>
          </div>
          <div class="col-md-5 col-lg-6 col-xl-5">
            <img
              src="/src/assets/img/illustrations/rhino_diving_combined.svg"
              alt=""
              class="rc-rhino-diving-combined"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- section 5 : Your Bookmarks at your fingertips-->
    <section class="rc-bg-wave-teal-2">
      <div class="container">
        <div class="row">
          <div class="col-md-5 col-lg-6 col-xl-5">
            <img
              src="/src/assets/img/illustrations/alligator_combined.svg"
              alt=""
              class="rc-alligator-combined"
            />
          </div>
          <div
            class="col-md-7 col-lg-6 col-xl-5 offset-xl-1 rc-col-text rc-col-max-width"
          >
            <h2 v-html="$t('statics.experience.section5.title')"></h2>
            <p
              class="rc-intro"
              v-html="$t('statics.experience.section5.text')"
            ></p>
          </div>
        </div>
      </div>
    </section>

    <!-- section 4 : Playlists for sharing -->
    <section>
      <div class="container">
        <div class="row">
          <div
            class="col-md-7 col-lg-6 col-xl-5 offset-xl-1 rc-col-text rc-col-max-width"
          >
            <h2 v-html="$t('statics.experience.section4.title')"></h2>
            <p
              class="rc-intro"
              v-html="$t('statics.experience.section4.text.1')"
            ></p>
            <p
              class="rc-intro"
              v-html="$t('statics.experience.section4.text.2')"
            ></p>
          </div>
          <div class="col-md-5 col-lg-6 col-xl-5">
            <img
              src="/src/assets/img/illustrations/playlist_combined.svg"
              alt=""
              class="rc-playlist-combined"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Widget verify subscription -->

    <template v-if="!isAuthenticated">
      <RcVerifySubscription cssClass="rc-verify-subscription bg-yellow" />
    </template>

    <!-- section 7 : Learn more-->
    <section
      class="rc-section-icons-h rc-section-last"
      :class="!isAuthenticated ? 'rc-bg-wave-white-3' : ''"
    >
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <h2 v-html="$t('statics.experience.section7.title')"></h2>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-6 col-xl-5">
            <div class="row rc-row-icons">
              <div class="col-md-auto">
                <img
                  src="/src/assets/img/illustrations/ic_contact.svg"
                  alt=""
                />
              </div>
              <div class="col rc-col-space-between">
                <h3
                  v-html="$t('statics.experience.section7.bloc.a.title')"
                ></h3>
                <div>
                  <!-- Contact us -->
                  <a
                    :href="$t('nav.url.contact_us')"
                    class="btn btn-dark btn-lg"
                    @click.prevent=""
                    data-bs-toggle="modal"
                    data-bs-target="#externalLinkModal"
                    >{{ $t("statics.experience.section7.bloc.a.cta") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-5">
            <div class="row rc-row-icons">
              <div class="col-md-auto">
                <img src="/src/assets/img/illustrations/ic_rocket.svg" alt="" />
              </div>
              <div class="col rc-col-space-between">
                <h3
                  v-html="$t('statics.experience.section7.bloc.b.title')"
                ></h3>
                <div>
                  <!-- Help Desk -->
                  <a
                    :href="$t('nav.url.help_desk')"
                    class="btn btn-dark btn-lg"
                    >{{ $t("statics.experience.section7.bloc.b.cta") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { navMixin } from "#/routes/mixins";

import RcVerifySubscription from "#/pages/market/components/sections/VerifySubscription.vue";

export default {
  name: "RcSiteExperience",
  components: {
    RcVerifySubscription
  },
  mixins: [navMixin],
  computed: {
    ...mapGetters(["isAuthenticated"])
  }
};
</script>

<style lang="scss"></style>
